import { fetchWrapper } from "@/helpers/fetch-wrapper";
import { useStatisticFiltersStore } from "@/stores/statisticFilters";

/**
 * Serwis do pobierania statystyk z API – wykresy, raporty itp.
 */
class Statistics {
  /**
   * Buduje string z parametrami GET na podstawie filtrów w store
   * - Pobiera aktualne filtry z useStatisticFiltersStore
   * - Zwraca string np. "&dateFrom=...&location=..." do dodania do URL
   */
  getQueryString() {
    const filtersStore = useStatisticFiltersStore();
    const keys =
      filtersStore && filtersStore.filters
        ? Object.keys(filtersStore.filters)
        : [];
    // Mapowanie wewnętrznych nazw filtrów na nazwy parametrów oczekiwane przez API.
    // Front trzyma kategorie pod kluczem "ctg8p1", ale endpoint statystyk czyta "categories" –
    // bez tego mapowania filtr kategorii był po cichu ignorowany (wykres dla wszystkich kategorii).
    const paramNameMap = {
      ctg8p1: "categories",
    };
    // Mapujemy klucze na "key=value" jeżeli wartość istnieje
    // (jeżeli jest niepustą tablicą lub > 0)
    return keys.length > 0
      ? "&" +
          keys
            .map((key) =>
              filtersStore.filters[key] &&
              (filtersStore.filters[key].length > 0 ||
                filtersStore.filters[key] > 0)
                ? (paramNameMap[key] || key) + "=" + filtersStore.filters[key]
                : ""
            )
            .join("&")
      : "";
  }

  /**
   * Pobiera dane wykresu statystyk (np. ruch drogowy, typ wykresu = barPlot)
   * - Zwraca obiekt zawierający dane + zakodowany base64 obraz wykresu
   */
  getGraph() {
    return fetchWrapper.get(
      `${process.env.VUE_APP_API_URL}/statistics/stat-1?statName=traffic&addLabel=true&addGraph=true&graphType=barPlot` +
        this.getQueryString()
    );
  }

  /**
   * Pobiera raport statystyk do pobrania (ZIP z wykresem/statystyką)
   */
  getZip() {
    return fetchWrapper.get(
      `${process.env.VUE_APP_API_URL}/statistics/report-1?statName=traffic&addLabel=true&addGraph=true&graphType=barPlot` +
        this.getQueryString()
    );
  }

  /**
   * Pobiera blob (np. ZIP) po linku z API – dla plików do pobrania
   * @param {string} zip - Link do pliku ZIP
   */
  fetch(zip) {
    // Czasami link może mieć /api/v1 na początku – usuń jeśli jest
    let zipNoStart = zip.includes("api/v1") ? zip.substr(7) : zip;
    return fetchWrapper.getBlob(process.env.VUE_APP_API_URL + zipNoStart);
  }
}

// Eksportujemy singleton serwisu – do użycia w komponentach
export default new Statistics();
